export enum DialogSize {
  normal = "normal",
  medium = "medium",
  big = "big",
  full = "full"
}
